<!-- src/app/time-attendance/components/payroll-sync/pages/payroll-unapproved-timesheets/payroll-unapproved-timesheets.component.html -->
<app-payroll-nav></app-payroll-nav>

<div class="approval-page">
    <div class="toast show" *ngIf="toastMessage" [class.success]="toastKind === 'success'"
        [class.error]="toastKind === 'error'" [class.warning]="toastKind === 'info'" (click)="clearToast()"
        role="status" aria-live="polite">
        <img class="icon"
            [src]="toastKind === 'success' ? '/success.png' : toastKind === 'error' ? '/fail.png' : '/warning.png'"
            alt="" aria-hidden="true" />

        <div class="toast-title">
            {{ toastKind === 'success' ? 'Success' : toastKind === 'error' ? 'Action needed' : 'Notice' }}
        </div>

        <div class="toast-body">{{ toastMessage }}</div>
    </div>

    <div class="page-header">
        <div class="title-block">
            <h2>Unapproved Timesheets</h2>
            <p class="subtitle">
                Review booked hours missing employee or supervisor approval before payroll sync.
            </p>
        </div>
    </div>

    <div *ngIf="errorMessage" class="inline-error" role="status" aria-live="polite">
        <p class="body">{{ errorMessage }}</p>
        <button type="button" class="icon-btn" (click)="errorMessage = null" aria-label="Close">×</button>
    </div>

    <div class="approval-card">
        <div class="card-head">
            <div class="head-left">
                <h3>Approval week</h3>
                <div class="sub">Previous completed week is selected automatically. You can change it.</div>
            </div>

            <div class="head-right">
                <span class="pill pill-muted" *ngIf="isLoadingRows">Loading rows…</span>
                <span class="pill" *ngIf="!isLoadingRows">{{ unapprovedRows.length }} unapproved</span>
            </div>
        </div>

        <div class="card-body">
            <div class="week-field">
                <label class="field-label">Payroll Week</label>

                <div class="combo">
                    <div class="combo-input" (click)="openYyww()" [class.disabled]="isLoading || isApprovingAll">
                        <span class="search-icon" aria-hidden="true">⌕</span>

                        <input type="text" [value]="yywwSearch" (input)="onYywwSearchChange($any($event.target).value)"
                            placeholder="Type year / YYWW (ex: 2026, 202620)…" [disabled]="isLoading || isApprovingAll"
                            aria-label="Search payroll weeks" />

                        <span class="combo-caret" aria-hidden="true">▾</span>
                    </div>

                    <div class="combo-panel" *ngIf="yywwOpen" role="dialog" aria-label="Payroll weeks"
                        (click)="$event.stopPropagation()">
                        <div class="combo-help">
                            Search updates automatically after you stop typing for <strong>1 second</strong>.
                        </div>

                        <div class="combo-list" (scroll)="onYywwScroll($event)" aria-live="polite" role="listbox">
                            <div class="combo-empty" *ngIf="!yywwIsLoading && !yywwResults.length">
                                No weeks found. Try another search.
                            </div>

                            <button type="button" class="combo-row" *ngFor="let w of yywwResults; trackBy: trackById"
                                (click)="selectWeekFromDropdown(w)" [class.selected]="selectedYyww?.id === w.id"
                                role="option" [attr.aria-selected]="selectedYyww?.id === w.id">
                                <div class="left">
                                    <div class="name">
                                        {{ w.fullYearWeek }}
                                        <span class="selected-dot" *ngIf="selectedYyww?.id === w.id">Selected</span>
                                    </div>

                                    <div class="meta" *ngIf="w.startDate && w.endDate">
                                        {{ w.startDate }} → {{ w.endDate }}
                                    </div>
                                </div>

                                <div class="right">
                                    <div class="tag">Week {{ w.week }}</div>
                                </div>
                            </button>

                            <div class="combo-loading" *ngIf="yywwIsLoading">
                                <div class="mini-spinner" aria-hidden="true"></div>
                                <span>Loading…</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field-help">
                    Selected: <strong>{{ selectedWeekSummary }}</strong>
                </div>
            </div>

            <div class="actions">

                <button type="button" class="primary-btn" (click)="openApproveAllConfirm()"
                    [disabled]="!hasRows || isApprovingAll || isLoadingRows">
                    <span class="btn-inline">
                        <span class="mini-spinner light" *ngIf="isApprovingAll" aria-hidden="true"></span>
                        {{ isApprovingAll ? 'Approving…' : 'Approve All' }}
                    </span>
                </button>
            </div>
        </div>
    </div>

    <div class="table-card">
        <div class="table-head">
            <div>
                <h3>Timesheets needing approval</h3>
                <div class="sub">{{ unapprovedRows.length }} rows require action</div>
            </div>
        </div>

        <div class="table-wrap">
            <table>
                <thead>
                    <tr>
                        <th>Employee</th>
                        <th>Date</th>
                        <th>Hours</th>
                        <th>Pay Code</th>
                        <th>WON</th>
                        <th>Supervisor Approved</th>
                        <th>Employee Approved</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let row of unapprovedRows; trackBy: trackById">
                        <td>
                            <div class="employee-cell">
                                <span class="employee-name">{{ getEmployeeName(row) }}</span>
                                <span class="muted">#{{ row.employee.employeeNumber }}</span>
                            </div>
                        </td>

                        <td>{{ row.bookedDate | date: 'shortDate' }}</td>

                        <td>
                            <span class="hours">{{ row.hours | number: '1.2-2' }}</span>
                        </td>

                        <td>{{ row.payCode?.name || '—' }}</td>

                        <td>
                            <div class="won-cell">
                                <span>{{ row.workOrderNumber?.won || '—' }}</span>
                                <span class="muted">{{ row.workOrderNumber?.description || '' }}</span>
                            </div>
                        </td>

                        <td>
                            <span class="approval-dot" [class.approved]="row.supervisorApprovedDate">
                                {{ row.supervisorApprovedDate ? 'Yes' : 'No' }}
                            </span>
                        </td>

                        <td>
                            <span class="approval-dot" [class.approved]="row.employeeApprovedDate">
                                {{ row.employeeApprovedDate ? 'Yes' : 'No' }}
                            </span>
                        </td>

                        <td class="row-actions">
                            <button type="button" class="primary-btn small" (click)="openApproveRowConfirm(row)"
                                [disabled]="isApproving(row) || isApprovingAll">
                                {{ isApproving(row) ? 'Approving…' : 'Approve' }}
                            </button>
                        </td>
                    </tr>

                    <tr *ngIf="!isLoadingRows && !unapprovedRows.length">
                        <td colspan="9" class="empty">
                            No unapproved timesheets found for the selected week.
                        </td>
                    </tr>

                    <tr *ngIf="isLoadingRows">
                        <td colspan="9" class="empty">
                            Loading unapproved timesheets...
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div *ngIf="confirmModalOpen" class="modal-backdrop">
        <div class="modal confirm-modal" (click)="$event.stopPropagation()">
            <h2>
                {{ confirmMode === 'all' ? 'Approve All Timesheets' : 'Approve Timesheet' }}
            </h2>

            <p class="modal-text" *ngIf="confirmMode === 'single' && rowToApprove">
                Are you sure you want to approve
                <strong>{{ getEmployeeName(rowToApprove) }}</strong>
                for <strong>{{ rowToApprove.bookedDate | date: 'shortDate' }}</strong>?
            </p>

            <p class="modal-text" *ngIf="confirmMode === 'all'">
                Are you sure you want to approve all
                <strong>{{ unapprovedRows.length }}</strong>
                unapproved timesheets for
                <strong>{{ selectedWeekSummary }}</strong>?
            </p>

            <div class="modal-buttons confirm-buttons">
                <button type="button" class="btn btn-secondary" (click)="cancelApproveConfirm()">
                    Cancel
                </button>

                <button type="button" class="btn btn-primary" (click)="confirmApprove()">
                    Approve
                </button>
            </div>
        </div>
    </div>

    <div *ngIf="isLoading" class="busy-overlay">
        <div class="spinner"></div>
    </div>
</div>